import { GzHealthDashboardUpdateStatusWebComponent } from './component/GzHealthDashboardUpdateStatusWebComponent';
import { GzHealthDashboardEndpointIssuesWebComponent } from './component/GzHealthDashboardEndpointIssuesWebComponent';
import { GzHealthDashboardPoliciesWebComponent } from './component/GzHealthDashboardPoliciesWebComponent';
import { GzHealthDashboardProductUpdateStatusWebComponent } from './component/GzHealthDashboardProductUpdateStatusWebComponent';
import { GzHealthDashboardSignatureUpdateStatusWebComponent } from './component/GzHealthDashboardSignatureUpdateStatusWebComponent';

export { GzHealthDashboardUpdateStatusWebComponent };
export { GzHealthDashboardEndpointIssuesWebComponent };
export { GzHealthDashboardPoliciesWebComponent };
export { GzHealthDashboardProductUpdateStatusWebComponent };
export { GzHealthDashboardSignatureUpdateStatusWebComponent };
